// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"e0a75035","453":"09296d8f","816":"92484ca2"}[chunkId] + ".chunk.js";
};